import * as React from "react"

import { CircleCheckIcon, CircleXIcon } from "lucide-react"

import { AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { cn } from "@/lib/utils"

type SummaryAccordionItemProps = {
  value: string
  title: string
  children: React.ReactNode
  checkIcon?: boolean
  /** Shown next to the title in place of the check icon. */
  badge?: React.ReactNode
}

export function SummaryAccordionItem({
  value,
  title,
  children,
  checkIcon = true,
  badge,
}: SummaryAccordionItemProps) {
  return (
    <AccordionItem
      value={value}
      className={cn(
        "border-0",
        badge && "rounded-md border border-gray-300 px-3",
      )}
    >
      <AccordionTrigger className="cursor-pointer transition-colors hover:opacity-80">
        <div className="flex w-full flex-1 items-center justify-between gap-2 [&[data-state=open]>svg]:rotate-0">
          {badge ? (
            <span className="flex items-center gap-2">
              <span className="font-medium">{title}</span>
              {badge}
            </span>
          ) : (
            <>
              <span className="font-medium">{title}</span>
              {checkIcon ? (
                <CircleCheckIcon className="text-success h-5 w-5" />
              ) : (
                <CircleXIcon className="text-destructive h-5 w-5" />
              )}
            </>
          )}
        </div>
      </AccordionTrigger>
      {children}
    </AccordionItem>
  )
}
